var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.options)?_c('div',{staticClass:"\n    select-none\n    flex-none\n    inline-flex\n    font-medium\n    group",class:[
    "hover:text-white",
    ("ripple-bg-" + (_vm.options.color || 'primary') + "-" + (_vm.options.colorIntensity || 500)),
    _vm.options.disabled
      ? 'opacity-33 pointer-events-none'
      : 'opacity-100',
    _vm.options.disabled
      ? 'cursor-not-allowed pointer-events-none'
      : 'cursor-pointer',
    _vm.options.outline
      ? ("text-" + (_vm.options.color || 'primary') + "-" + (_vm.options.colorIntensity || 500))
      : "text-white",
    _vm.options.outline
      ? ("border-2 border-" + (_vm.options.color || 'primary') + "-" + (_vm.options.colorIntensity || 500) + "\n        border-solid")
      : '',
    _vm.options.outline
      ? "bg-white"
      :'',
    _vm.options.outline
      ? ("hover:bg-" + (_vm.options.color || 'primary') + "-" + (_vm.options.colorIntensity || 500))
      : '',
    _vm.options.pill || _vm.options.fab ? 'rounded-full': '',
    _vm.options.round ? 'rounded' : '',
    _vm.options.flat ? 'shadow-none': 'elevation-4',
    _vm.options.class,
    _vm.iconPadding ],on:{"click":_vm.handleClick}},[(_vm.options.loading)?[_c('Loader',{staticClass:"px-32",attrs:{"size":"18"}})]:[(_vm.options.to)?_c('router-link',{staticClass:"flex flex-none items-center",class:[
      _vm.options.iconRight ? 'flex-row-reverse' : 'flex-row' ],attrs:{"to":_vm.options.to}},[(_vm.options.icon)?_c('v-icon',{class:[
        'text-2xl',
        'group-hover:text-white',
        _vm.options.outline
          ? ("text-" + (_vm.options.color || 'primary') + "-" + (_vm.options.colorIntensity || 500))
          : "text-white",
        _vm.iconMargin
      ]},[_vm._v(_vm._s(_vm.options.icon))]):_vm._e(),(!_vm.options.fab)?_c('span',{staticClass:"text-button"},[_vm._v(_vm._s(_vm.options.label || 'No Label Set'))]):_vm._e()],1):_c('div',{staticClass:"flex flex-none items-center text-base",class:[
      _vm.options.iconRight ? 'flex-row-reverse' : 'flex-row' ],attrs:{"to":_vm.options.to}},[(_vm.options.icon)?_c('v-icon',{class:[
        'text-2xl',
        'group-hover:text-white',
        _vm.options.outline
          ? ("text-" + (_vm.options.color || 'primary') + "-" + (_vm.options.colorIntensity || 500))
          : "text-white",
        _vm.iconMargin
      ]},[_vm._v(_vm._s(_vm.options.icon))]):_vm._e(),(!_vm.options.fab)?_c('span',{staticClass:"text-button font-semibold"},[_vm._v(_vm._s(_vm.options.label || 'No Label Set'))]):_vm._e()],1)]],2):_c('span',[_vm._v("oops... this button has no options")])}
var staticRenderFns = []

export { render, staticRenderFns }